import React, { useEffect } from 'react';
import { Provider } from 'react-redux';
import { BrowserRouter } from 'react-router-dom';
import store from './store';
import history from './history';
import Layouts from './layouts';
import './lang';
import GlobalToastProvider from './_v2/components/GlobalToastProvider';

function App() {

  useEffect(() => {
    const onWheel = (e) => {
      const el = document.activeElement;
      if (el && el.tagName === "INPUT" && el.type === "number") {
        e.preventDefault(); // stop value from changing
      }
    };
    // passive:false is REQUIRED so preventDefault works on wheel
    window.addEventListener("wheel", onWheel, { passive: false });
    return () => window.removeEventListener("wheel", onWheel);
  }, []);

  return (
    <div className="App">
      <Provider store={store}>
        <BrowserRouter history={history}>
          <GlobalToastProvider>
            <Layouts />
          </GlobalToastProvider>
        </BrowserRouter>
      </Provider>
    </div>
  );
}

export default App;
